import React, { useEffect, useState } from 'react';
import styles from './AnimatedHandle.module.scss';

interface IAnimatedHandle {
  handleDrawerOpened: () => void;
  isActive: boolean;
  title: string;
  filterCount?: number;
}

const AnimatedHandle = ({
  handleDrawerOpened,
  isActive,
  title,
  filterCount,
}: IAnimatedHandle) => {
  const [isHandleActive, setIsHandleActive] = useState(isActive);
  const handleClick = () => {
    setIsHandleActive(!isHandleActive);
    handleDrawerOpened();
  };

  useEffect(() => {
    setIsHandleActive(isActive);
  }, [isActive]);

  return (
    <button type="button" className={styles.Wrapper} onClick={() => handleClick()}>
      <div className={styles.Title}>
        {title}
        {
          (filterCount && filterCount > 0)
            ? <span className={styles.FilterCount}> ({filterCount})</span>
            : null
        }
      </div>
      <div className={`${styles.AnimatedHandle} ${isHandleActive ? styles.Active : ''}`}>
        <div>
          <div className={styles.HandleWrapper}>
            <span />
            <span />
          </div>
        </div>
      </div>
    </button>
  );
};

export default AnimatedHandle;
